import {useAppContext} from 'contexts';
import React from 'react';
import {parseHtmlString} from 'shared/helpers/HTMLParser';
import styled from 'styled-components';

const DispatchNote: React.FC = () => {
    const {userProfile} = useAppContext();

    return (
        <FormNote>
            <section>
                <Title>Note:</Title>
                {parseHtmlString(userProfile?.manufacturerFreightText)}
            </section>
        </FormNote>
    );
};

const FormNote = styled.div`
    border: 1px solid #ffe0b2;
    box-sizing: border-box;
    font-size: 0.75em;
    background: #fff3e0;
    padding: 12px;
    border-radius: 8px;
    color: #6b6f70;
    margin-bottom: 15px;

    ul {
        padding-left: 18px;
        margin-bottom: 0;
    }

    // make headings in the manufacturer's text just bigger, not the
    // app's primary coloured header bars
    && h1,
    && h2 {
        display: block;
        background: none;
        color: inherit;
        padding: 0;
        border-radius: 0;
        margin: 0 0 10px;
        font-weight: 600;
    }

    && h1 {
        font-size: 1.4em;
    }

    && h2 {
        font-size: 1.2em;
    }
`;

const Title = styled.p`
    margin: 0;
    font-weight: 600;
    margin-bottom: 10px;
`;

export default DispatchNote;
